import { render, staticRenderFns } from "./modal-register.vue?vue&type=template&id=dd36286c&scoped=true"
import script from "./modal-register.vue?vue&type=script&lang=js"
export * from "./modal-register.vue?vue&type=script&lang=js"
import style0 from "./modal-register.vue?vue&type=style&index=0&id=dd36286c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd36286c",
  null
  
)

export default component.exports